export default "__VITE_ASSET__ButfgXQ8__"